import { getStatValue } from '@frontend/core/lib/domains/reporting/types'
import type { PlayerSummaryStats } from '@frontend/core'

/**
 * Access a stat field by string accessor on the PlayerSummaryStats union type.
 *
 * WHY: PlayerSummaryStats is a union of SoccerPlayerSummaryStats and
 * AmericanFootballPlayerSummaryStats. TypeScript won't let you write
 * `stats.passesAttempted` because it can't know which sport's interface applies.
 * Instead, the sport config declares accessor strings (e.g., 'passesAttempted'),
 * and this function does the cast + extraction in one place.
 *
 * The cast to Record<string, unknown> is safe here because:
 *  1. The sport config is the source of truth for which accessors are valid
 *  2. Tests verify that config accessors match the actual type interfaces
 *  3. getStatValue() handles the StatValue | number | null ambiguity
 */
export function getStatByAccessor(
  stats: PlayerSummaryStats | undefined | null,
  accessor: string
): number | null {
  if (!stats) return null
  const val = (stats as Record<string, unknown>)[accessor]
  return getStatValue(val as Parameters<typeof getStatValue>[0])
}
